import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from "classnames";

import UserCardStyles from "components/menu/UserCard.module.scss";

import { Hamburger } from "components/icons/Hamburger";
import { Bell } from "components/icons/Bell";
import { UiActions } from "state/actions/UiActions";
import { GlamboxBadge } from "core/glambox/GlamboxBadge";
import { InstagramIcon } from "components/icons/InstagramIcon";

class UserCard extends Component {
  constructor (props) {
    super(props);

    this.setBadgeClass = this.setBadgeClass.bind(this);
    this.setUserAvatar = this.setUserAvatar.bind(this);
    this.memberSince = this.memberSince.bind(this);
    this.menuShow = this.menuShow.bind(this);
    this.notifsShow = this.notifsShow.bind(this);
  }

  setBadgeClass () {
    let badgeClass = null,
        badge = this.props.person.badge;

    if (badge !== undefined && badge !== null && badge.badgeId) {
      badgeClass = GlamboxBadge.getJewelSlug(
        badge.badgeId
      );
    }

    return badgeClass;
  }

  setUserAvatar () {
    
    let { insta } = this.props.person;
    const { instagramInfo } = this.props;
    
    if (insta.isActive && instagramInfo) {
      return (
        <img src={instagramInfo.profile_pic_url} alt={""}/>
      );
    }
    
    return null;
  }

  memberSince (date) {
    let memberDate = new Date(date);
    let year = memberDate.getFullYear();
    let months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ];

    return months[memberDate.getMonth()] + "/" + year;
  }

  menuShow () {
    this.props.showMenu();
  }

  notifsShow () {
    this.props.showNotifs();
  }

  hasNotificationsUnread = () => {
    let {
      notifs
    } = this.props;

    if (notifs === null) return false;

    let unreadOrDismissed = notifs.filter((item) => {
      return (item.dateRead === null && item.dateDismiss === null);
    });

    return (unreadOrDismissed.length > 0);
  };

  connectToInstagram = () => {
    const {
      person
    } = this.props.person;

    //let newRedirectUrl = window.location.origin + "/register-instagram?personId=" + person.personId;
    let personId = person.id;
    let redirectURL =
      process.env.REACT_APP_GB_APP_ROOT + "/register-instagram"; //"?personId=" + personId;
    let instaUrl =
      "https://api.instagram.com/oauth/authorize/?client_id=" +
      //+ process.env.REACT_APP_INSTAGRAM_CLIENT_ID
      process.env.REACT_APP_INSTAGRAM_APP_ID +
      "&response_type=code&redirect_uri=" +
      redirectURL +
      "&scope=user_profile,user_media";

    // let redirectUrl = process.env.REACT_APP_GB_APP_ROOT + "/register-instagram?personId=" + person.id,
    //     instaUrl = "https://www.instagram.com/oauth/authorize/?client_id=" 
    //       + process.env.REACT_APP_INSTAGRAM_CLIENT_ID
    //       + "&response_type=code&redirect_uri=" + redirectUrl;
    window.location.href = instaUrl;
  };

  renderUserAvatarOrInstagramLink = () => {
    const { insta } = this.props.person;

    if (insta === null || insta.isActive === false) {
      return (
        <button className={UserCardStyles["user-card__avatar"]} onClick={this.connectToInstagram}>
          <InstagramIcon size={"100%"}/>
          <span className={UserCardStyles["tooltip"]}>
            <span>Conecte com o Instagram</span>
          </span>
        </button>
      );
    }

    return (
      <div className={UserCardStyles["user-card__avatar"]}>
        <figure>
          {this.setUserAvatar()}
        </figure>
      </div>
    );
  };

  render () {
    let _cls;
    
    const { person } = this.props.person;
    if(!person) return null;

    let _notifCls = [UserCardStyles["user-card__button_notifications"]];
    if (this.hasNotificationsUnread()) {
      _notifCls.push(UserCardStyles["unread"]);
    }

    if ( this.props.ui.mobile === true ) {
      _cls = [
        UserCardStyles["user-card__mobile"]
      ];

      if (this.setBadgeClass() !== null) {
        _cls.push(UserCardStyles[this.setBadgeClass()]);
      }

      return (
        <header className={classnames(_cls)}>
          <button 
            className={UserCardStyles["user-card__button"]}
            onClick={this.menuShow}>
            <Hamburger fill={"#fff"} size={"100%"}/>
          </button>
          <div className={UserCardStyles["user-card__info"]}>
            <h5>{person.name} {person.lastName}</h5>
            <small className={"text-uppercase"}>
              Desde: {this.memberSince(person.dateCreated)}
            </small>
          </div>
          <button 
            className={classnames(_notifCls)}
            onClick={this.notifsShow}>
            <Bell fill={"#fff"} size={"100%"}/>
          </button>
        </header>
      );
    }

    _cls = [
      UserCardStyles["user-card"]
    ];

    if (this.setBadgeClass() !== null) {
      _cls.push(UserCardStyles[this.setBadgeClass()]);
    }

    return (
      <header className={classnames(_cls)}>
        {this.renderUserAvatarOrInstagramLink()}
        <div className={UserCardStyles["user-card__info"]}>
          <h5>{person.name} {person.lastName}</h5>
          <small className={"text-uppercase"}>
            Desde: {this.memberSince(person.dateCreated)}
          </small>
        </div>
        <button 
          className={classnames(_notifCls)}
          onClick={this.notifsShow}>
          <Bell fill={"#fff"} size={"100%"}/>
        </button>
      </header>
    );
  }
}

const mapStateToProps = (state) => ({
  person: state.person.data,
  notifs: state.notifs.data,
  ui: state.ui,
  instagramInfo: state.instagramInfo.data
});

const mapDispatchToProps = (dispatch) => ({
  showMenu: () => {
    dispatch(UiActions.menuShow())
  },
  showNotifs: () => {
    dispatch(UiActions.notifsShow())
  }
});

UserCard = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserCard);

export {
  UserCard
};
